<template>
  <div class="overflow-hidden" style="height: 100%;">
    <!--门禁-->
    <div style="padding-top: 15px;font-weight: bold;margin-left: 25px;">
      <span
        style="width: 5px;height: 15px;border-left: 2px solid #299FFB;display: inline-block;margin-bottom: -2px;margin-right: 5px;"
      ></span>
      <span>门禁</span>
    </div>
    <el-tabs style="margin: 10px 25px;" v-model="activeId">
      <!-- <el-tab-pane label="中控" name="1">
        <ZKDoor :deviceList="zkDoorList"></ZKDoor>
      </el-tab-pane>
      <el-tab-pane label="联投" name="2">
        <LTDoor :deviceList="ltDoorList"></LTDoor>
      </el-tab-pane>
      <el-tab-pane label="微耕" name="3">
        <el-row style="margin: 10px 0 15px 0;font-size: 0.9rem">
          <ul style="clear: both">
            <li>
              <el-radio-group size="small" v-model="currentSelectDoorId">
                <el-radio-button :key="item.id" :label="item.id" v-for="item in doorList">{{
                    item.name
                  }}
                </el-radio-button>
              </el-radio-group>
            </li>
          </ul>
        </el-row>
        <el-row style="margin: 0 0 0 25px;font-size: 0.9rem">
          <ul>
            <li>
              <img src="../../../assets/images/comprehensive/门禁记录.png" style="margin-bottom: 2px;">
              <span class="ml-1 mr-1" style="font-weight: bold">门禁记录</span>
            </li>
            <li style="color: rgba(41, 159, 251, 1);font-weight: bold">
              <span v-if="doorLogs.count > 0">
            {{ doorLogs.count ? '共' + doorLogs.count + '条' : '暂无记录' }}
          </span>
              <span v-else-if="diDoorLogs.length <= 0">
            暂无记录
          </span>
            </li>
          </ul>
        </el-row>
        <div class="h-100 overflow">
          <el-row :key="item.id" style="margin-left: 35px;margin-top: 10px;font-size: 0.9rem"
                  v-for="item in diDoorLogs">
            <div class="p-3" style="width: 92%;border: 1px solid rgba(41, 155, 255, .2);border-radius: 5px;">
              <el-row style="margin-top: 5px;">开门时间：{{ item.commitTime }}</el-row>
            </div>
          </el-row>
          <el-row :key="item.id" style="margin-left: 35px;margin-top: 10px;font-size: 0.9rem"
                  v-for="item in doorLogs.data">
            <div class="p-3" style="width: 92%;border: 1px solid rgba(41, 155, 255, .2);border-radius: 5px;">
              <el-row>卡号：{{ item.card }}</el-row>
              <el-row style="margin-top: 5px;" v-if="item.name">员工名：{{ item.name }}</el-row>
              <el-row style="margin-top: 5px;">工号：{{ item.number }}</el-row>
              <el-row style="margin-top: 5px;" v-if="item.section">部门名称：{{ item.section }}</el-row>
              <el-row style="margin-top: 5px;">记录类型：{{ item.log }}</el-row>
              <el-row style="margin-top: 5px;">门名称：{{ item.door }}</el-row>
              <el-row style="margin-top: 5px;">开门时间：{{ item.time }}</el-row>
            </div>
          </el-row>
          <el-pagination
            :current-page="doorLogs.index + 1"
            :hide-on-single-page="true" :page-size="doorLogs.size"
            :pager-count="5"
            :small="true"
            :total="doorLogs.count"
            @current-change="pageChange"
            class="mb-4 mt-3 text-center"
            layout="prev, pager, next"
            style="padding-left: 35px;width: 92%;"
            v-if="diDoorLogs.length <= 0">
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="海康" name="4">
        <HKDoor :deviceList="hkDoorList"></HKDoor>
      </el-tab-pane>-->
      <!-- 翠湖项目 -->
      <!-- <el-tab-pane label="海康" name="1">
        <HikDoorOV :deviceList="hkDoorList"></HikDoorOV>
      </el-tab-pane>-->
      <!-- <el-tab-pane label="达实" name="1">
          <DasDoorOV :deviceList="dasDoorList"></DasDoorOV>
      </el-tab-pane>-->
      <el-tab-pane label="英菲斯达" name="1">
        <div style="display: flex; flex-direction: column;">
          <div style="margin-top: 10px; max-height: calc(100vh - 350px); overflow-y: auto;">
            <el-table
              :data="doorLogs.data"
              class="table no-row-border"
              :cell-style="{borderColor: 'transparent'}"
              :header-cell-style="{borderColor: 'none'}"
              style="width: 100%;"
            >
              <el-table-column align="center" label="记录类型" prop="log"></el-table-column>
            </el-table>
          </div>
          <div v-if="shouldShowPagination" style="margin-top: 20px; margin-bottom: 30px; padding: 10px 0; display: flex; justify-content: center; align-items: center;">
            <el-pagination
              :current-page.sync="doorGetSetting.data.page"
              :page-size="pageSize"
              :total="doorLogs.count"
              @current-change="handleCurrentChange"
              layout="prev, pager, next"
              style="width: auto;"
            ></el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getDeviceList } from "@/network/device-info";
import { getPageByDeviceId } from "@/network/measuring-point-history";
// import HKDoor from "@/components/component/comprehensive_situation/HKDoor";
// import LTDoor from "@/components/component/comprehensive_situation/LTDoor";
// import ZKDoor from "@/components/component/comprehensive_situation/ZKDoor";
// 翠湖项目
// import DasDoorOV from "@/components/component/comprehensive_situation/DasDoorOV";

export default {
  name: "Door",
  props: {
    spaceId: {
      type: String,
      default: () => ""
    }
  },
  inject: ["overflow"],
  // components: {HKDoor,LTDoor,ZKDoor},
  // components: { DasDoorOV },
  data() {
    return {
      websocket: null,
      //门磁信号
      diDoorList: [],
      // 门设备列表
      doorList: [], //微耕
      hkDoorList: [], //海康
      ltDoorList: [], //联投
      zkDoorList: [], //中控
      dasDoorList: [], //达实
      yfsdDoorList: [], //英菲斯达
      // 当前选中门的id
      currentSelectDoorId: "",
      // 获取开门记录的请求参数
      doorGetSetting: {
        command: "getLogs",
        data: {
          page: 1, //记录分页的页数
          index: 0,
          max: 3
        }
      },
      // 开门记录
      doorLogs: {},
      // DI 信号的开门记录
      diDoorLogs: [],
      activeId: "1",
      commandId: null, // 用于跟踪消息ID
      isConnecting: false, // WebSocket连接状态标志
      currentDeviceId: null // 当前连接的设备ID，用于避免重复连接
    };
  },
  methods: {
    // 翻页（用于微耕等旧的分页方式）
    pageChange(page) {
      this.doorGetSetting.data.index = page - 1;
      this.sendGetLogs();
    },
    // 计算序号（用于英菲斯达表格）
    changeIndex(val) {
      return (this.doorGetSetting.data.page - 1) * this.doorGetSetting.data.max + val + 1;
    },
    // 处理分页变化（用于英菲斯达）
    handleCurrentChange(val) {
      this.doorGetSetting.data.page = val;
      this.doorGetSetting.data.index = this.doorGetSetting.data.max * (val - 1);
      this.sendGetLogs();
    },
    // 获取当前空间的门禁设备
    getDoorDevices() {
      if (!this.spaceId) {
        return;
      }
      this.doorList = [];
      this.hkDoorList = [];
      this.ltDoorList = [];
      this.zkDoorList = [];
      this.dasDoorList = [];
      this.yfsdDoorList = [];
      this.initData();
      this.diDoorLogs = [];
      getDeviceList(this.spaceId, "PM_Access1").then(res => {
        if (res.data) {
          res.data.forEach(item => {
            if (item.brandCnName === "海康") {
              this.hkDoorList.push(item);
            } else if (item.brandCnName === "联投") {
              this.ltDoorList.push(item);
            } else if (item.brandCnName === "ZKTeco") {
              this.zkDoorList.push(item);
            } else if (item.brandCnName === "达实") {
              this.dasDoorList.push(item);
            } else if (item.brandCnName === "英菲斯达") {
              this.yfsdDoorList.push(item);
            } else {
              this.doorList.push(item);
            }
          });
          // 优先使用英菲斯达设备，如果没有则使用其他设备
          if (this.yfsdDoorList.length > 0) {
            this.currentSelectDoorId = this.yfsdDoorList[0].id;
          } else {
            this.currentSelectDoorId =
              this.doorList.length > 0 ? this.doorList[0].id : "";
          }
          this.initDoorAndDiDoor();
        }
      });
    },
    // 初始化门磁信号和连接门禁
    initDoorAndDiDoor() {
      // 如果没有选中的设备，不进行初始化
      if (!this.currentSelectDoorId) {
        return;
      }
      
      // 从所有设备列表中查找当前选中的设备
      let allDoorList = [
        ...this.doorList,
        ...this.yfsdDoorList,
        ...this.hkDoorList,
        ...this.ltDoorList,
        ...this.zkDoorList,
        ...this.dasDoorList
      ];
      let doorDevice = allDoorList.filter(
        item => item.id === this.currentSelectDoorId
      );
      
      if (doorDevice && doorDevice[0]) {
        const deviceType = doorDevice[0].typeEngName ? doorDevice[0].typeEngName.trim() : "";
        if (deviceType === "PM_Access" || deviceType === "PM_Access1") {
          this.initDoorWebsocket(doorDevice[0]);
        } else {
          this.initDiDoor(doorDevice[0]);
        }
      }
    },
    // 初始化门磁信号
    initDiDoor(device) {
      getPageByDeviceId(
        device.id,
        this.doorGetSetting.data.index,
        this.doorGetSetting.data.max,
        "0"
      ).then(res => {
        if (res.data) {
          this.diDoorLogs = res.data;
        }
      });
    },
    // 初始化websocket
    initDoorWebsocket(doorDevice) {
      // 如果已经连接到同一个设备，且连接正常，不需要重复连接
      if (this.currentDeviceId === doorDevice.id && 
          this.websocket && 
          this.websocket.readyState === WebSocket.OPEN) {
        console.log("已连接到该设备，跳过重复连接:", doorDevice.id);
        return;
      }
      
      // 如果正在连接中，避免重复连接
      if (this.isConnecting) {
        console.log("正在连接中，跳过重复连接");
        return;
      }
      
      // 关闭现有连接（如果是不同设备）
      if (this.websocket && this.currentDeviceId !== doorDevice.id) {
        try {
          if (this.websocket.readyState === WebSocket.CONNECTING || 
              this.websocket.readyState === WebSocket.OPEN) {
            console.log("关闭旧设备连接:", this.currentDeviceId);
            this.websocket.close();
          }
        } catch (e) {
          console.log("关闭WebSocket连接时出错:", e);
        }
        this.websocket = null;
      }
      
      this.initData();
      
      // 兼容两种数据结构：portProperties 和 attribute
      let properties;
      if (doorDevice.portProperties) {
        try {
          properties = JSON.parse(doorDevice.portProperties);
        } catch (e) {
          console.error("解析portProperties失败:", e);
          return;
        }
      } else if (doorDevice.attribute) {
        properties = doorDevice.attribute;
      } else {
        console.error("设备配置信息不存在");
        return;
      }
      
      // 根据设备类型选择连接方式（参考Default.vue，优先使用直接连接）
      let wsUrl;
      if (properties.IP && properties.PORT) {
        // 优先使用直接连接方式（参考Default.vue）
        wsUrl = "ws://" + properties.IP + ":" + properties.PORT;
      } else {
        console.error("设备IP或端口配置不存在");
        return;
      }
      
      this.isConnecting = true;
      
      try {
        this.websocket = new WebSocket(wsUrl);
        
        // 连接成功
        this.websocket.onopen = () => {
          this.isConnecting = false;
          this.currentDeviceId = doorDevice.id;
          console.log("WebSocket连接成功:", wsUrl, "设备ID:", doorDevice.id);
          this.sendGetLogs();
        };
        
        // 错误处理
        this.websocket.onerror = (error) => {
          this.isConnecting = false;
          this.currentDeviceId = null;
          console.log("WebSocket连接出错:", error);
          this.initData();
        };
        
        // 连接关闭
        this.websocket.onclose = (event) => {
          this.isConnecting = false;
          const closedDeviceId = doorDevice.id; // 保存设备ID到闭包中
          // 只有当前设备连接关闭时才清除
          if (this.currentDeviceId === closedDeviceId) {
            this.currentDeviceId = null;
            this.websocket = null;
          }
          console.log("WebSocket连接关闭:", event.code, event.reason, "设备ID:", closedDeviceId);
        };
        
        // 消息回调
        this.websocket.onmessage = e => {
          try {
            let websocketObj = JSON.parse(e.data);
            if (websocketObj.command && typeof this[websocketObj.command] === 'function') {
              this[websocketObj.command](websocketObj);
            } else {
              console.warn("未知的WebSocket命令:", websocketObj.command);
            }
          } catch (error) {
            console.error("解析WebSocket消息失败:", error, e.data);
          }
        };
      } catch (error) {
        this.isConnecting = false;
        console.error("创建WebSocket连接失败:", error);
        this.initData();
      }
    },
    // 向门禁发送获取开门记录命令
    sendGetLogs() {
      if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
        try {
          this.websocket.send(JSON.stringify(this.doorGetSetting));
        } catch (error) {
          console.error("发送WebSocket消息失败:", error);
        }
      } else {
        console.warn("WebSocket未连接，无法发送消息");
      }
    },
    // 获取开门记录回调
    getLogs(data) {
      if (data) {
        // 直接赋值，Vue 2 会自动处理响应式
        this.doorLogs = data;
        console.log("门禁记录数据:", this.doorLogs);
        console.log("count:", this.doorLogs.count, "max:", this.doorLogs.max);
        console.log("应该显示分页:", this.shouldShowPagination);
      } else {
        this.doorLogs = {};
      }
    },
    // 刷卡数据消息回调（实时消息处理）
    message(data) {
      if (data.data && data.data.id !== this.commandId) {
        this.commandId = data.data.id;
        this.sendGetLogs();
      }
    },
    // 初始化数据
    initData() {
      this.doorLogs = {};
      this.commandId = null;
    }
  },
  computed: {
    // 是否显示分页
    shouldShowPagination() {
      const count = this.doorLogs && this.doorLogs.count;
      const max = (this.doorLogs && this.doorLogs.max) || this.doorGetSetting.data.max;
      return count && count > 0 && max && count > max;
    },
    // 每页显示数量
    pageSize() {
      return (this.doorLogs && this.doorLogs.max) || this.doorGetSetting.data.max;
    }
  },
  mounted() {
    this.overflow();
    this.getDoorDevices();
  },
  destroyed() {
    this.isConnecting = false;
    this.currentDeviceId = null;
    if (this.websocket) {
      try {
        if (this.websocket.readyState === WebSocket.CONNECTING || 
            this.websocket.readyState === WebSocket.OPEN) {
          this.websocket.close();
        }
      } catch (e) {
        console.log("关闭WebSocket连接时出错:", e);
      }
      this.websocket = null;
    }
  },
  watch: {
    spaceId() {
      this.currentDeviceId = null; // 切换空间时清除设备ID
      this.getDoorDevices();
    },
    currentSelectDoorId(newVal, oldVal) {
      // 如果设备ID没有变化，不需要重新初始化
      if (newVal === oldVal) {
        return;
      }
      this.currentDeviceId = null; // 切换设备时清除设备ID
      this.initData();
      this.diDoorLogs = [];
      this.initDoorAndDiDoor();
    }
  }
};
</script>

<style scoped>
ul li,
ul {
  padding: 0;
  float: left;
  list-style: none;
}
</style>
